import { Icon } from '../icon'
import { ColorName } from './colors'

export interface DesignSystemThemeConfig {
  icon: Icon
  primaryColor: ColorName
}

/**
 * Consult the Design System Figma for a list of themes/symbolism in the FTR app.
 * @see {@link https://www.figma.com/design/sjVw2qSQGLSFCnz6yTlQkz/Design-System?node-id=17361-9052 Design System Figma}
 */
export const DesignSystemTheme = {
  Cart: {
    icon: 'Cart',
    primaryColor: 'Grey40',
  },
  Case: {
    icon: 'CaseLine',
    primaryColor: 'Mint50',
  },
  Content: {
    icon: 'ContentLine',
    primaryColor: 'Grape50',
  },
  Courthouse: {
    icon: 'CourthouseLine',
    primaryColor: 'Grey40',
  },
  Courtroom: {
    icon: 'CourtroomLine',
    primaryColor: 'Grey40',
  },
  CourtSystem: {
    icon: 'CourtSystem',
    primaryColor: 'Grey40',
  },
  Department: {
    icon: 'Department',
    primaryColor: 'Grey40',
  },
  DisplayScreen: {
    icon: 'DisplayScreen',
    primaryColor: 'Grey40',
  },
  Document: {
    icon: 'DocumentLine',
    primaryColor: 'Lemon50',
  },
  Error: {
    icon: 'ErrorCircleLine',
    primaryColor: 'Error40',
  },
  Export: {
    icon: 'Export',
    primaryColor: 'Primary40',
  },
  Gold: {
    icon: 'ContentLine',
    primaryColor: 'Lemon50',
  },
  Hearing: {
    icon: 'HearingLine',
    primaryColor: 'Mint40',
  },
  Judge: {
    icon: 'JudgeLine',
    primaryColor: 'Grey40',
  },
  JusticeCloud: {
    icon: 'CloudLine',
    primaryColor: 'Grape50',
  },
  Organization: {
    icon: 'GroupLine',
    primaryColor: 'Grape50',
  },
  Recorder: {
    icon: 'RecorderLine',
    primaryColor: 'Grey40',
  },
  Recording: {
    icon: 'Recordings',
    primaryColor: 'Blueberry50',
  },
  RecordingRequest: {
    icon: 'RecordingRequest',
    primaryColor: 'Blueberry50',
  },
  Report: {
    icon: 'BarGraphVertical',
    primaryColor: 'Primary40',
  },
  Requests: {
    icon: 'Requests',
    primaryColor: 'Watermelon40',
  },
  Search: {
    icon: 'Search',
    primaryColor: 'Primary40',
  },
  Success: {
    icon: 'CheckmarkCircleLine',
    primaryColor: 'Apple40',
  },
  Transcript: {
    icon: 'Transcript',
    primaryColor: 'Lemon50',
  },
  UpcomingHearing: {
    icon: 'CalendarMonthLine',
    primaryColor: 'Grape50',
  },
  Upload: {
    icon: 'Upload',
    primaryColor: 'Mandarin50',
  },
  User: {
    icon: 'PersonLine',
    primaryColor: 'Mint50',
  },
  Users: {
    icon: 'UsersLine',
    primaryColor: 'Mint50',
  },
  Video: {
    icon: 'VideoLine',
    primaryColor: 'Grey40',
  },
  Warning: {
    icon: 'WarningLine',
    primaryColor: 'Mandarin40',
  },
} as const satisfies Record<string, DesignSystemThemeConfig>
export type DesignSystemTheme = keyof typeof DesignSystemTheme
